module.exports = __webpack_public_path__ + "img/i-pimentos.657bccbd.svg";